module.exports = __webpack_public_path__ + "img/termscondition-bg.1330eb72.png";